import React, { useEffect } from "react";
import { WifiOff, CircleAlert } from "lucide-react";

interface NetworkDisconnectedWarningProps {
  show: boolean;
  onClose?: () => void;
}

export const NetworkDisconnectedWarning: React.FC<NetworkDisconnectedWarningProps> = ({
  show,
  onClose,
}) => {
  // Debug logging
  useEffect(() => {
    console.log("NetworkDisconnectedWarning props:", { show });
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="w-[480px] h-[338px] p-10 bg-[#131314] rounded-3xl border border-[#ec3f3f] flex flex-col justify-start items-start gap-2.5 overflow-hidden">
        <div className="self-stretch h-[258px] flex flex-col justify-center items-center gap-10">
          {/* Main content section */}
          <div className="self-stretch h-[180px] flex flex-col justify-start items-center gap-3">
            {/* Icon container with background circle */}
            <div className="w-[60px] h-[60px] relative flex justify-center items-center">
              <div className="w-[60px] h-[60px] absolute bg-[#ec4040]/20 rounded-full" />
              <WifiOff
                className="w-7 h-7 text-[#ec4040] z-10"
                strokeWidth={2}
                aria-label="Network disconnected icon"
              />
            </div>

            {/* Title and subtitle section */}
            <div className="self-stretch h-[52px] flex flex-col justify-start items-center gap-1">
              <h1 className="text-center text-white text-2xl font-bold font-satoshi leading-7">
                Network Connection Lost
              </h1>
            </div>

            {/* Description text */}
            <p className="self-stretch text-center text-white/70 text-base font-normal font-satoshi leading-normal">
              The video call cannot continue without a stable network connection. Please contact the recruiter if you believe this was in error.
            </p>
          </div>

          {/* Alert */}
          <div className="px-4 py-2 bg-[#ec4040]/20 rounded flex justify-start items-center gap-2">
            <CircleAlert
              className="w-5 h-5 text-[#ec4040]"
              strokeWidth={2}
              aria-hidden="true"
            />
            <span className="text-center text-[#ec4040] text-base font-normal font-satoshi">
              Interview Ended
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}; 